// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class AuthorizationOutput {
  readonly fullUrl: string;

  constructor(data: { [key: string]: any } = {}) {
    this.fullUrl = data.fullUrl === undefined ? '' : data.fullUrl;
  }

  static zero(): AuthorizationOutput {
    const zeroValues: ExcludeMethodsDeep<AuthorizationOutput> = {
      fullUrl: '',
    };
    return new AuthorizationOutput(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type AuthorizationOutputWireFormat = {
  fullUrl: string;
};

type NewAuthorizationOutputProps = PartialDeep<AuthorizationOutput, { recurseIntoArrays: true }>;
export const NewAuthorizationOutput: (props: NewAuthorizationOutputProps) => AuthorizationOutput = (
  props,
) => new AuthorizationOutput(props);

type NewAuthorizationOutputFromWireFormatProps = PartialDeep<
  AuthorizationOutputWireFormat,
  { recurseIntoArrays: true }
>;
export const NewAuthorizationOutputFromWireFormat: (
  props: NewAuthorizationOutputFromWireFormatProps,
) => AuthorizationOutput = (props) => new AuthorizationOutput(props);
